import './ColorSelect.sass';
import { useEffect, useState } from 'react';

export default function ColorSelect(props) {
  const { products, selectedVariant, onChange, defaultVariantId, title = 'Choose Your Option' } = props;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!products || products.length === 0) {
      setOptions([]);
      return;
    }

    const uniqueVariants = new Map();
    products.forEach((product) => {
      const colorName = product.color || product.variantValue;
      const colorImage = product.colorImage || product.colorimage || product.variantImage;

      if (colorName && !uniqueVariants.has(colorName)) {
        uniqueVariants.set(colorName, {
          name: colorName,
          imageSrc: colorImage,
          id: product.id,
        });
      }
    });

    const colorOptions = Array.from(uniqueVariants.values());

    const sortedOptions = [...colorOptions].sort((a, b) => {
      const isADefault = String(a.id) === String(defaultVariantId);
      const isBDefault = String(b.id) === String(defaultVariantId);

      if (isADefault && !isBDefault) {
        return -1; // a (default) comes first
      }
      if (!isADefault && isBDefault) {
        return 1; // b (default) comes first
      }

      return 0; // Keep original order if no default match or secondary sort needed
    });

    setOptions(sortedOptions);
  }, [products, defaultVariantId]);

  return (
    <div className='color-select'>
      <div className='color-select__title'>{title}</div>
      <div className='color-select-items'>
        {options.map((item) => (
          <div
            className={`color-select__item ${selectedVariant?.name === item.name ? 'active' : ''}`}
            key={item.name}
            style={{ width: options.length > 0 ? `${100 / options.length}%` : '100%' }}
            onClick={() => onChange(item)}
          >
            {item.imageSrc && <img src={item.imageSrc} alt={item.name} />}
            <p>{item.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
